import { render, staticRenderFns } from "./TouristInfoBasic.vue?vue&type=template&id=54ede5e6&"
import script from "./TouristInfoBasic.vue?vue&type=script&lang=js&"
export * from "./TouristInfoBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports